<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-payroll-payroll-banks-dialog-create
          v-if="$hasPermissionTo(['create payroll banks'])"
          @created="loadPayrollBanks"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Payroll Bank's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in payroll bank here"
          append-icon="search"
          label="Search Payroll Bank"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <v-data-table
      :headers="headers"
      :items="filteredPayrollBanks"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.name="{ item }">
        <div>
          <span>
            {{ item.name }}
          </span>
        </div>
      </template>

      <template v-slot:item.shift_code="{ item }">
        <div>
          <span>
            {{ item.shift_code }}
          </span>
        </div>
      </template>

      <template v-slot:item.bank_code="{ item }">
        <div>
          <span>
            {{ item.bank_code }}
          </span>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-payroll-payroll-banks-dialog-edit
            v-if="$hasPermissionTo(['update payroll banks'])"
            :payroll-bank="item"
            @updated="loadPayrollBanks"
          />
          <span class="mx-1" />
          <setup-payroll-payroll-banks-dialog-delete
            v-if="$hasPermissionTo(['delete payroll banks']) && $vuetify.breakpoint.mdAndUp"
            :payroll-bank="item"
            @deleted="refreshData"
          />
        </span>
        <span v-else>
          <setup-payroll-payroll-banks-dialog-restore
            v-if="$hasPermissionTo(['restore payroll banks']) && $vuetify.breakpoint.mdAndUp"
            :payroll-bank="item"
            @restored="refreshData"
          />
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupPayrollPayrollBanksDialogCreate: () => import('@/components/hris/setup/payroll/payroll-bank/DialogCreate'),
      SetupPayrollPayrollBanksDialogEdit: () => import('@/components/hris/setup/payroll/payroll-bank/DialogEdit'),
      SetupPayrollPayrollBanksDialogDelete: () => import('@/components/hris/setup/payroll/payroll-bank/DialogDelete'),
      SetupPayrollPayrollBanksDialogRestore: () => import('@/components/hris/setup/payroll/payroll-bank/DialogRestore'),
    },
    data () {
      return {
        payrollBanks: [],
        trashedPayrollBanks: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Swift Code',
            align: 'left',
            value: 'shift_code',
            sortable: false,
          },
          {
            text: 'Bank Code',
            align: 'left',
            value: 'bank_code',
            sortable: false,
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: false,
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
      }
    },
    computed: {
      filteredPayrollBanks () {
        return this.statusFilter ? this.payrollBanks : this.trashedPayrollBanks
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadPayrollBanks () {
        this.tableLoading = true

        this.$api.payrollBanks().list()
          .then(res => {
            this.payrollBanks = _.orderBy(res.data, ['name'], ['asc'])

            this.tableLoading = false
          })
      },
      loadTrashedPayrollBanks () {
        this.$api.payrollBanks().listTrashed()
          .then(response => {
            this.trashedPayrollBanks = response.data
          })
      },
      refreshData () {
        this.loadPayrollBanks()
        this.loadTrashedPayrollBanks()
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}

.border-bottom-light-grey{
  border-bottom:1px solid #e6e6e6;
}

.accordion-max-height{
  max-height: 36px !important;
}

.border{
  border:1px solid #e6e6e6;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
  padding-left:0px
}

.selected{
  background-color: rgba(0, 0, 0, .05);
}

.remove-bottom-border {
  border-bottom: 0px !important
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}
</style>
